import React, { useState, useEffect } from 'react'
import VerEstados from './VerEstados.js'
import SubirEstados from './SubirEstados.js'
// import EditarUsuario from './EditarUsuario.js'
import axios from 'axios'
//import Eliminar from '.../componentes/Eliminar.js'
import Eliminar from '../../componentes/Eliminar.js'
import Header from '../../componentes/Header.js';
import Paginacion from '../../componentes/Paginacion.js'

const CampanasAdmin = ({ baseUrl, Titulo, cursos, baseUrlEstados, urlUsuarios, urlCampanas }) => {

	//almacena toda la data de categorias 
	const [tituloPag, setTituloPag] = useState(Titulo)
	const [error, setError] = useState({ activo: false })
	const [data, setData] = useState([])
	const [usuarioSelect, setUsuarioSelect] = useState({})
	const [funcion, setFuncion] = useState('cargando')
	const [alerta, setAlerta] = useState(false)

	const [copiaArray, setCopiaArray] = useState([])
	const [busqueda, setBusqueda] = useState('')

	const PAGINACION = 15
	const [numPaginas, setNumPaginas] = useState()
	const [numRegistros, setNumRegistros] = useState()
	const [paginaAct, setPaginaAct] = useState(1);
	const [dataFiltrado, setDataFiltrado] = useState([])
	const [estados, setEstados] = useState([])

	const RecibeBusqueda = e => {
		setBusqueda(e.target.value)
		filtrar(e.target.value)
	}

	const filtrar = (termino) => {
		let resultado = copiaArray.filter((item) => {
			if (item.nombre.toLowerCase().includes(termino.toLowerCase()) || item.usuario.toLowerCase().includes(termino.toLowerCase())) {
				return item
			}
		})
		setDataFiltrado(resultado)
	}

	const peticionTraeDatos = () => {
		axios.get(urlCampanas)
			.then(response => {
				setData(response.data)
				setCopiaArray(response.data)
				setDataFiltrado([...response.data].splice(0, PAGINACION))
				setNumPaginas(Math.ceil(response.data.length / PAGINACION))
				setNumRegistros(response.data.length)
				setFuncion('ver')
			}).catch(error => {
				console.log(error)
			})

		axios.get(baseUrlEstados)
			.then(response => {
				setEstados(response.data)
			}).catch(error => {
				console.log(error)
			})
	}

	//realiza petición que borra de la base de datos por medio de la ID
	const peticionDelete = async () => {
		let f = new FormData();
		f.append("METHOD", "DELETE");
		await axios.post(baseUrl, f, { params: { id: usuarioSelect.id } })
			.then(response => {
				setData(data.filter(categoria => categoria.id !== usuarioSelect.id))
				setDataFiltrado(dataFiltrado.filter(categoria => categoria.id !== usuarioSelect.id))
				setFuncion('ver')
			}).catch(error => {
				console.log(error)
			})
	}


	//Selecciona categoria para editarla o borrarla 
	const Seleccionar = (objeto, funcion) => e => {
		setFuncion(funcion)
		setUsuarioSelect(objeto)
		if (funcion === 'editar') { setFuncion('editar') }
	}

	//Trae todas las categorias de la api
	useEffect(() => { peticionTraeDatos() }, [])

	useEffect(() => {
		switch (funcion) {
			case 'ver': return setTituloPag('Ver Campañas')
			case 'crear': return setTituloPag('Crear Campaña')
			case 'editar': return setTituloPag('Editar Campaña')
			case 'eliminar': return setTituloPag('Eliminar Campaña')
			default: return setTituloPag('Campañas')
		}
	}, [funcion])

	const ReiniciarPaginacion = () => {
		setDataFiltrado([...data].splice(0, PAGINACION))
		setBusqueda('')
	}

	return (
		<div>
			<Header titulo={tituloPag} funcion={funcion} setFuncion={setFuncion} Pagina={'Estados'} />
			<div style={{ alignItems: 'flex-end' }}>
				<Paginacion
					data={data}
					setDataFiltrado={setDataFiltrado}
					PAGINACION={PAGINACION}
					numPaginas={numPaginas}
					paginaAct={paginaAct}
					setPaginaAct={setPaginaAct}
				/>
			</div>
			<div className="row">
				<div className="col-md-12">

					{funcion === 'editar' ?
						<SubirEstados
							baseUrl={urlUsuarios}
							setFuncion={setFuncion}
							funcion={funcion}
							registroSelect={usuarioSelect}
							peticionTraeDatos={peticionTraeDatos}
							estados={estados}
						/>
						: null}
					{funcion === 'eliminar' ?
						<Eliminar
							nombre={'Estado'}
							select={usuarioSelect}
							setFuncion={setFuncion}
							peticionDelete={peticionDelete}
						/>
						: null}
					{funcion === 'cargando' ?
						<div className="loader">Loading...</div>
						: null}
					{funcion === 'ver' ?
						<VerEstados
							data={dataFiltrado}
							seleccionaRegistro={Seleccionar}
						/>
						: null}
					{funcion === 'crear' ?
						<SubirEstados
							baseUrl={baseUrl}
							setFuncion={setFuncion}
							funcion={funcion}
							peticionTraeDatos={peticionTraeDatos}
							estados={estados}
							urlCampanas={urlCampanas}
						/>
						: null}
				</div>
			</div>
		</div>
	)
}

export default CampanasAdmin